/**
 * App Reducer
 *
 * Fetch Me - React Native
 * Ashan Beruwalage <ashan@interlective.com>
 * https://bitbucket.org/interlective/fetch-me-react-native
 */

// Set initial state

export const initialState = {
    isLoading_posts: false,
    error: "",
    data:[]
};

export default function postReducer(state = initialState, action) {
    switch (action.type) {
        case "RESET_POSTS":
            return {
                ...state,
                data:[]
            };
        case "SET_POSTS":
            return {
                ...state,
                data: action.data
            };
        case "LOADING_POSTS":
            return {
                ...state,
                isLoading_posts: action.loading,
                error: action.error
            };

        default:
            return state;
    }
}
